import {
    SEE_CONTACT_REQUESTS, SEE_CONTACT_LIST, SEE_BLOCKED_CONTACT_LIST, IS_LOADING_CONTACTS, ACCEPT_CONTACT_REQUEST, CANCEL_CONTACT_REQUEST, IS_LOADING_CONTACT_LIST, DELETE_CONTACT,
    BLOCK_CONTACT, IS_LOADING_BLOCKED_CONTACT_LIST, UNBLOCK_CONTACT, IS_LOADING_FOLLOWING_LIST, UNFOLLOW_USER, IS_LOADING_FOLLOWERS_LIST, IS_LOADING_DATA_PROFILE,
    ADD_COUNT_COMMENT_POST_PROFILE, IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE, DELETE_COUNT_COMMENT_POST_PROFILE, 
    GET_RELATION_BETWEEN,IS_LOADING_CONTACTS_REQUEST, LOAD_CONTACT_RELATION_BETWEEN,CHANGE_CONTACT_RELATION_BETWEEN,IS_LOADING_GET_USER_INFO,GET_PROFESSIONAL_LIST,IS_LOADING_GET_PROFESSIONAL_LIST
} from '../actions/types'

const initialState = {
    professionalList:[],
    isLoadingProfessionalList:false,
    userContactRequests:[],
    isLoadingContactRequestList:false,
    contactList:{},
    isLoadingContactsList:true
}

export default function (state = initialState, action) {
    switch (action.type) {
      
      
        case IS_LOADING_CONTACT_LIST:
            return { ...state, isLoadingContactsList: true }
        case SEE_CONTACT_LIST:
            return { ...state, contactList: action.payload, isLoadingContactsList: false }
        case SEE_CONTACT_REQUESTS:
            return { ...state, userContactRequests: action.payload, isLoadingContactRequestList: false }
        case IS_LOADING_CONTACTS_REQUEST:
            return { ...state, isLoadingContactRequestList: true }
        case ACCEPT_CONTACT_REQUEST:
            var acceptContact = state.userContactRequests
            delete acceptContact[action.payload]
            return { ...state, isLoadingContactRequestList: false, userContactRequests: acceptContact }
        case CANCEL_CONTACT_REQUEST:
            var cancelContact = state.userContactRequests
            delete cancelContact[action.payload]
            return { ...state, isLoadingContactRequestList: false, userContactRequests: cancelContact }
        case DELETE_CONTACT:
            var deleteContact = state.contactList
            delete deleteContact[action.payload]
            return { ...state, isLoadingContactsList: false, contactList: deleteContact } 
        case LOAD_CONTACT_RELATION_BETWEEN:
            return { ...state, isLoadingRelationBetween:false }
        case CHANGE_CONTACT_RELATION_BETWEEN:
            return { ...state, relationBetween: action.payload, isLoadingRelationBetween:true }
        case GET_PROFESSIONAL_LIST:
            return { ...state, professionalList: action.payload, isLoadingProfessionalList:false }
        case IS_LOADING_GET_PROFESSIONAL_LIST:
            return { ...state, isLoadingProfessionalList:true }
        default:
            return state
        
    }
}